import React, { useContext, useEffect, useState, useCallback } from 'react';
import { RadioGroup, Input, Switch } from '@progress/kendo-react-inputs';
import { Label } from '@progress/kendo-react-labels';
import ListEditor from '../../ListEditor';
import SwimlineContent from '../swimlineContent';
import { LocalizationContext } from '../../../contexts';
import './index.scss';
import '../forms.scss';

export default function SwimlineListContent({ data, settingsData = {}, onUpdate, validator, ...rest }) {
  const emptyItem = { title: "", items: [{ title: "", id: "", isPublish: false }] };
  const [compData, setCompData] = useState({});
  const [localization] = useContext(LocalizationContext);
  const { labels } = localization;

  validator.current = () => {
    return true;
  };

  useEffect(() => {
    let defaultData = { items: [JSON.parse(JSON.stringify(emptyItem))], title: "" };
    const startCompData = { ...defaultData, ...JSON.parse(JSON.stringify(data ? data : {})) };
    if (startCompData.items.length === 0) {
      startCompData.items = [JSON.parse(JSON.stringify(emptyItem))];
    }
    setCompData(startCompData);
  }, [data]);

  const updateItem = useCallback((i, newData) => {
    let newCompData;
    if (i !== null) {
      newCompData = { ...compData };
      newCompData.items[i] = { ...(newCompData.items[i]), ...newData };
    } else {
      newCompData = { ...compData, ...newData };
    }
    setCompData(newCompData);
    onUpdate(newCompData);
  }, [compData]);

  const title = (settings) => {
    return settingsData.title ? eval("`" + settingsData.title + "`") : false;
  };

  const isEmptyItem = () => {
    return JSON.stringify(compData) === JSON.stringify(emptyItem.current)
  }

  const showRequired = (requiredField) => {
    return (!isEmptyItem() && !requiredField)
  }

  const startElement = <>
    <div className="form-field">
      <label className="form-field__label mandatory">{labels.pagesManagement.forms.add_title}</label>
      <Input name={'swimlineTitle'} value={compData.title} onChange={({ value }) => updateItem(null, { title: value })}></Input>
      {showRequired(compData.title) && <div className="form-field__required">{labels.pagesManagement.forms.required}</div>}
    </div>
  </>;

  const itemTitle = (item, settings) => {
    return `${labels.pagesManagement.swimlineListContent.item} ${settings.index + 1}: ${item.title || ''} (${(item.items && item.items.length) || 0}/10) (${item.isPublish ? labels.pagesManagement.swimlineListContent.is_publish : labels.pagesManagement.swimlineListContent.publish_ready})`;
  };

  const itemContent = (item, settings) => {
    return <>
      <SwimlineContent
        data={item}
        settingsData={{ line_location: settingsData.line_location, title: false }}
        onUpdate={(newData) => { updateItem(settings.index, { ...newData }) }}
        {...rest}
      />
      <div className="form-field">
        <Label className="form-field__label inline_label">{labels.pagesManagement.swimlineListContent.publish_title} </Label>
        <Switch checked={item && item.isPublish} onChange={(event) => updateItem(settings.index, { isPublish: event.target.value })} />
        <Label className="form-field__label inline_label"> {item.isPublish ? labels.pagesManagement.swimlineListContent.is_publish : labels.pagesManagement.swimlineListContent.publish_ready}</Label>
      </div>
    </>;
  };

  return <ListEditor
    isSortable={true}
    canRemove={true}
    canAdd={true}
    removeContentOnClose={false}
    maxSize={10}
    minSize={0}
    className="swimlineListContent-listEditor"
    addNewItemBtnText={labels.pagesManagement.swimlineListContent.addNewItemBtnText}
    title={title}
    startElement={startElement}
    emptyItem={emptyItem}
    itemTitle={itemTitle}
    itemContent={itemContent}
    list={[...(compData.items || [])]}
    onListUpdate={(newList) => { updateItem(null, { items: newList }) }}
  />;
};